<template>
  <div>
<!--    todo simple form with validations-->
    <p>Submit</p>
    <form class="mt-5" @submit.prevent="submitForm">

      <Text v-model="text" :required="required" label="Text"></Text>
      <Number v-model="numberValue" :required="required" label="Numeric (numbers only)" />
      <Number v-model="decimalValue" :required="false" label="Decimal (optional)" :is-decimal="true" />
      <Gender v-model="gender" :required="required" />

      <v-otp-input
          v-model:value="validation"
          input-classes="otp-input"
          separator=""
          :num-inputs="6"
          :should-auto-focus="true"
          input-type="number"
      />

<!--      <div class="error" v-if="!$v.name.required">Field is required</div>-->
      <small class="p-error" id="text-error">fxdgdfgcfgh</small>


      <Button type="submit" label="Submit" @click.prevent="v.$validate"></Button>
    </form>

  </div>
</template>
<script setup>
import { ref } from 'vue'
import useValidate from '@vuelidate/core'
import Text from "@/components/input/Text.vue";
import Number from "@/components/input/Number.vue";
import Gender from '@/components/input/Gender.vue'
import VOtpInput from "vue3-otp-input";

const required = ref(true)
const gender = ref('')
const text = ref('')
const numberValue = ref(null)
const decimalValue = ref(null)
const validation = ref('')
const v = useValidate()

const submitForm = async () => {
  const result = await v.value.$validate()
  if (result) {
    alert('success')
  } else {
    alert('error')
  }
}
</script>
